import React, { useContext, useState, useEffect } from "react";
import TeamInfoCard from "../components/TeamInfoCard";
import { InfoContext } from "../components/InfoContext";
import LeagueTable from "../components/LeagueTable";
import GroupManageCard from "../components/dashboard-page/components/GroupManageCard";
import { PlatformContext } from "../components/Platform/PlatformContext";
import { TournamentBracket } from "../components/Bracket";

const Table: React.FC = () => {
  const { seasons, getSeasonById } = useContext(InfoContext);
  const [selectedSeasonId, setSelectedSeasonId] = useState("");
  const [viewMode, setViewMode] = useState("knockout");
  const platform = useContext(PlatformContext);
  const isMobile = !platform?.isDesktop;

  useEffect(() => {
    if (seasons.length > 0) {
      const maxId = Math.max(...seasons.map((season) => season.id));
      setSelectedSeasonId(String(maxId));
    }
  }, [seasons]);

  const selectedSeasonIdInt = parseInt(selectedSeasonId, 10);
  const selectedSeason = getSeasonById(selectedSeasonIdInt);

  return (
    <div className="p-4 text-white">
      <h2 className="flex justify-center mb-6 mt-4 text-3xl font-semibold text-left text-white ">
        Table
      </h2>
      <form className="flex justify-center  text-black mb-8 rounded-xl shadow-md w-full gap-y-4">
        <select
          id="teamSelect"
          value={selectedSeasonId}
          onChange={(e) => setSelectedSeasonId(e.target.value)}
          className="w-full max-w-32 px-3 py-2 border rounded-xl "
          required
        >
          {seasons.map((season) => (
            <option key={season.id} value={season.id}>
              {season.name}
            </option>
          ))}
        </select>
      </form>
      <div className="tabs relative flex w-64 bg-white/10 p-1 rounded-xl mx-auto mb-4">
        <div
          className={`absolute top-0 left-0 h-full w-1/2 bg-white/20 rounded-xl transition-transform duration-300 ease-in-out transform ${
            viewMode === "group" ? "translate-x-0" : "translate-x-full"
          }`}
        />
        <button
          className={`relative z-10 flex-1 py-2 text-center font-medium w-1/2 ${
            viewMode === "group" ? "text-white" : "text-gray-400"
          }`}
          onClick={() => setViewMode("group")}
        >
          Group Stage
        </button>
        <button
          className={`relative z-10 flex-1 py-2 text-center font-medium w-1/2 ${
            viewMode === "knockout" ? "text-white" : "text-gray-400"
          }`}
          onClick={() => setViewMode("knockout")}
        >
          Knockout Stage
        </button>
      </div>
      <div className="flex flex-col min-h-[600px]">
        <div className="flex flex-wrap max-w-[1250px] mx-auto gap-4 justify-around">
          {viewMode === "group" &&
            selectedSeason?.groups.map((group) => (
              <GroupManageCard
                key={group.id}
                group={group}
                season_id={selectedSeasonIdInt}
                isMobile={isMobile}
              />
            ))}
        </div>
        <div className="flex items-center justify-center w-full py-4">
          <div className="max-w-[1120px] w-full overflow-auto">
            {viewMode === "knockout" && (
              <TournamentBracket
                mobileBreakpoint={992}
                season={selectedSeason!}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Table;
